// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupList__container-dd31f8 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.GroupList__available-title-c5b664 {
  font: var(--font-button);
  letter-spacing: var(--font-spacing-button);
  color: var(--base-70);
  padding: 16px 16px 0px 16px;
}

.GroupList__list-df5311 {
  flex: 1;
}

.GroupList__empty-list-stub-a417b7 {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--base-80);
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/GroupList/GroupList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,2BAAA;AACF;;AAEA;EACE,OAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0CAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.available-title {\n  font: var(--font-button);\n  letter-spacing: var(--font-spacing-button);\n  color: var(--base-70);\n  padding: 16px 16px 0px 16px;\n}\n\n.list {\n  flex: 1;\n}\n\n.empty-list-stub {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--base-80);\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GroupList__container-dd31f8`,
	"available-title": `GroupList__available-title-c5b664`,
	"availableTitle": `GroupList__available-title-c5b664`,
	"list": `GroupList__list-df5311`,
	"empty-list-stub": `GroupList__empty-list-stub-a417b7`,
	"emptyListStub": `GroupList__empty-list-stub-a417b7`
};
module.exports = ___CSS_LOADER_EXPORT___;
